<script setup>
import { storeToRefs } from 'pinia'
import Illustration1 from 'assets/illustrations/illu-01.svg?url'
import { useMessageStore } from '~/stores/messages'

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Markdown
const { $md } = useNuxtApp()
const errorTxt = computed(() => $md.renderInline(staticKeys.value?.general_error_no_salesforcedata_markdown || ''))
</script>

<template>
    <SideBarWrapper class="support-note-container">
        <SideBarHeader>
            <SideBarMainHeadline :sidebar-main-headline-config="{ title: staticKeys?.general_error_headline }" />
            <p class="sidebar-support-text" v-html=" errorTxt" />
        </SideBarHeader>

        <img :src="Illustration1" :alt="staticKeys?.general_error_headline">
    </SideBarWrapper>
</template>

<style lang="scss">
.support-note-container {
    display: flex;
    flex-flow: row wrap;
    height: 100%;

    .side-bar-header {
        width: 100%;
    }

    img {
        width: 100%;
        margin-block-start: auto;
    }
}

.sidebar-support-text {
    @include body1-medium;

    a {
        color: inherit;
        text-decoration: underline;
    }
}
</style>
